// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3XNNj","rootSmall":"AddTileButton_rootSmall__3KmjH"};